// extracted by mini-css-extract-plugin
module.exports = {"navLinksWrapper":"AppNavLinks_navLinksWrapper__2aVKg","navLink":"AppNavLinks_navLink__2phLz","live":"AppNavLinks_live__3GenE","navActive":"AppNavLinks_navActive__1WaFJ"};